import { apiClient } from './apiClient';

const FILES = 'Files';

export const FileServiceAPI = {
	/** Fetches an image file (authenticated) and returns an object URL, or null when not found. */
	getImageObjectUrl: async (id: string): Promise<string | null> => {
		const response = await apiClient.get(`${FILES}/${id}/image`, { responseType: 'arraybuffer' });
		if (response?.data) {
			const contentType = response.headers['content-type'];
			const blob = new Blob([response.data], { type: contentType });
			return URL.createObjectURL(blob);
		}
		return null;
	},
};
